import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import locationIcon from "../../../img/svg/carousel_location_icon.svg";
import ImageWithFallback from "../../../shared/imageWithFallback";
import { formatDistance } from "../../utils/geo";

function ClubPeekCard({ club, price, defaultClubImg, imgFallbackSrc }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const distanceLabel = formatDistance(club.distanceMeters, t);

  const openVenue = () =>
    navigate(`/venue/${club.ClubID}`, {
      state: {
        clubId: club.ClubID,
        clubName: club.ClubName,
        // GetCarousels carries no price; venue re-derives it from the club list
        // via chooseTextForBtn, which is the authoritative source.
        price: undefined,
        // Explicit: venue.jsx reads location.state.ignoreApiCall unguarded.
        ignoreApiCall: false,
      },
    });

  return (
    <div className="hm-v2-card" onClick={openVenue}>
      <div className="hm-v2-card-img">
        <ImageWithFallback src={defaultClubImg || club.ImageUrl} fallbackSrc={imgFallbackSrc} alt="" />
      </div>
      <p className="hm-v2-card-name">{club.ClubName}</p>
      {/* Distance, bullet and address are separate elements on purpose: "•" is
          bidi-neutral, and concatenating it next to a digit run makes it jump. */}
      <p className="hm-v2-card-meta">
        {distanceLabel && (
          <>
            <span className="hm-v2-card-distance">
              <img src={locationIcon} alt="" className="hm-v2-card-distance-icon" />
              {distanceLabel}
            </span>
            <span className="hm-v2-card-dot" aria-hidden="true">
              •
            </span>
          </>
        )}
        <span className="hm-v2-card-address">{club.Address}</span>
      </p>
      {price != null && <p className="hm-v2-card-price">{t("CLUB_PRICE", { price })}</p>}
    </div>
  );
}

export default ClubPeekCard;
